// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__6NAjJ","loader--svg":"Loader_loader--svg__HJlla"};